import { render, staticRenderFns } from "./ExamGroupList.vue?vue&type=template&id=30452479&scoped=true&"
import script from "./ExamGroupList.vue?vue&type=script&lang=js&"
export * from "./ExamGroupList.vue?vue&type=script&lang=js&"
import style0 from "./ExamGroupList.vue?vue&type=style&index=0&id=30452479&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30452479",
  null
  
)

export default component.exports